import { initialState, State } from 'mk2/apps/strollers/containers/StrollersComparison/StrollersComparison.reducers';
import { AppState } from 'mk2/reducers';

export const getStrollersComparisonState = (state: AppState): State =>
    state.containers.strollers.strollersComparison || initialState;
